<template>
  <div class="text-center">
    <p class="text-xl font-semibold text-gray-800">
      {{ props.value }}
    </p>
    <p class="mt-1 text-xs font-medium uppercase text-gray-600">
      {{ props.label }}
    </p>
  </div>
</template>

<script lang="ts" setup>
type Props = {
  label: string;
  value: string | number;
};

const props = defineProps<Props>();

</script>
